<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Filter Samples'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <!-- Field of Use Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="fieldOfUseOptions"
                    [(ngModel)]="filters.fieldOfUse"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="field-of-use"
                    filter="false"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%'}"
            ></p-multiSelect>
            <label for="field-of-use">Field of Use</label>
        </p-ifta-label>

        <!-- Sample Type Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleTypeOptions"
                    [(ngModel)]="filters.sampleType"
                    optionLabel="name"
                    class="w-full"
                    appendTo="body"
                    id="sample-type"
                    filter="false"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%'}"
            ></p-multiSelect>
            <label for="sample-type">Sample Type</label>
        </p-ifta-label>

        <!-- State Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleStateOptions"
                    [(ngModel)]="filters.sampleState"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="sample-state"
                    filter="false"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%'}"
            ></p-multiSelect>
            <label for="sample-state">State</label>
        </p-ifta-label>

        <!-- Category Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleCategoryOptions"
                    [(ngModel)]="filters.sampleCategory"
                    optionLabel="name"
                    class="w-full"
                    appendTo="body"
                    id="category"
                    filter="false"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%'}"
            ></p-multiSelect>
            <label for="category">Category</label>
        </p-ifta-label>

        <!-- Details Filter -->
        <p-ifta-label>
            <p-multi-select
                    [options]="sampleDetailOptions"
                    [(ngModel)]="filters.sampleDetails"
                    optionLabel="name"
                    class="w-full"
                    appendTo="body"
                    id="details"
                    filter="true"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%'}"
            ></p-multi-select>
            <label for="details">Details</label>
        </p-ifta-label>


        <!-- Sample Format Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleFormatOptions"
                    [(ngModel)]="filters.format"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="sample-format"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%' }"
            ></p-multiSelect>
            <label for="sample-format">Format</label>
        </p-ifta-label>

    </div>

    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Reset"
                icon="pi pi-filter-slash"
                (click)="resetFilters()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Apply"
                icon="pi pi-check"
                (click)="applyFilters()"
        ></p-button>
    </div>
</p-dialog>
